import type { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const columnLinksStyles = makeStyles((theme: Theme) => ({
    wrapContent: {
        padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`
    },
    icon: {
        cursor: 'pointer',
        fontSize: '22px',
        minWidth: '22px',
        maxWidth: '22px',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        borderRadius: '50%',
        padding: '7px',
        marginRight: theme.spacing(2)
    },
    iconNotDeveloped: {
        pointerEvents: 'none',
        backgroundColor: theme.palette.grey['400']
    },
    categoryTitle: {
        cursor: 'pointer',
        fontWeight: 'bold',
        color: theme.palette.primary.main
    },
    titleNotDeveloped: {
        pointerEvents: 'none',
        textDecoration: 'line-through',
        color: theme.palette.grey['500']
    },
    categoryBody: {
        fontWeight: 500
    },
    noPermission: {
        pointerEvents: 'none',
        color: theme.palette.grey['500']
    }
}));

export default columnLinksStyles;
